import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'c-wizard-step',
    templateUrl: './wizard-step.component.html',
    styleUrls: ['./wizard-step.component.scss'],
    standalone: false
})
export class WizardStepComponent implements OnInit {
  @Input() name: string;
  @Input() activeStep: string;
  @Input() required: boolean;

  constructor() {}

  ngOnInit() {}
}
